/**
 * See more trigger
 */
(() => {
  document.querySelectorAll('.popular-items')
    .forEach((popularItems) => {
      popularItems.querySelectorAll('.see-more')
        .forEach((seeMoreTrigger) => {
          seeMoreTrigger.textContent = 'See more';
          seeMoreTrigger.addEventListener('click', () => {
            popularItems.classList.toggle('open');
            seeMoreTrigger.textContent = popularItems.classList.contains('open') ? 'See less' : 'See more';
          });
        });
    });
})();
